const DELAY = isMobile() ? 1500 : 0;
const SURVEY_EVENT_ACCEPT = 'ticketAccept';
const SURVEY_EVENT_REJECT = 'ticketReject';

const versions = Object.freeze({
    accepted: 'accepted',
    redemptionFlow: 'redemptionFlow',
    rejected: 'rejected',
    refund: 'refund',
    processingRedemption: 'processingRedemption',
});

const versionsKeys = Object.freeze({
    accepted: 'accepted',
    redemptionFlow: 'accepted',
    rejected: 'rejected',
    refund: 'refund',
    processingRedemption: 'processingRedemption',
});

function appSplashOverlay(view, bookingInfo) {
    const module = {};
    let el = null;
    let lastVersion = '';
    const destinationCityIata = Odigeo._.get(bookingInfo, 'itineraryBookings.bookingItinerary.arrival.cityIataCode');
    const cityName = Odigeo._.get(bookingInfo, 'itineraryBookings.bookingItinerary.arrival.cityName');
    const cityImageUrl = getImageUrl(destinationCityIata);
    const fallbackImageUrl = getImageUrl('XXX');
    const buyerName = Odigeo._.capitalize(Odigeo._.get(bookingInfo, 'buyer.name'));
    const bookingId = Odigeo._.get(bookingInfo, 'bookingBasicInfo.id');

    module.open = function open(version = '', pnrInfo = {}, delay = DELAY, notificationManagerScope = false) {
        lastVersion = version;
        el = renderTemplate(view, version, {cityImageUrl, pnrInfo, cityName, buyerName, fallbackImageUrl, bookingId, notificationManagerScope});
        view.el.appendChild(el);
        setTimeout(() => {
            el.classList.add('open');
            Odigeo.Device.getViewport().addClass(view.CSS_CLASSES.OD_OVERFLOW);
        }, delay);
    };

    module.close = function close() {
        el.classList.remove('open');
        Odigeo.Device.getViewport().removeClass(view.CSS_CLASSES.OD_OVERFLOW);
        setTimeout(() => {
            view.el.removeChild(el);
            el = null;
        }, 500);

        setTimeout(() => openSurvey(view, lastVersion), DELAY);
    };

    module.trackClose = function(e) {
        if (isMobile()) {
            trackCloseMobile(e);
        } else {
            trackCloseDesktop(e);
        }
    };

    module.trackCloseBackground = function(e) {
        if (isMobile()) {
            trackCloseBackground(e, view.TRACKING.PAGE.ACCEPTED_LAYER);
        } else {
            trackCloseBackground(e, view.TRACKING.PAGE.CUSTOMER_SUPPORT_LAYER);
        }
    };

    function trackCloseBackground(e, pag) {
        const $currentTarget = $(e.currentTarget);
        const version = $currentTarget.attr('data-splash-version');
        const pnr = $currentTarget.attr('data-openticket-pnr');
        let customTrackingParams = {};

        view.TRACKING.CLOSE_APP_SPLASH_BG.PNR = pnr;

        if (version === 'refund') {
            view.trackEventWithData(view.TRACKING.CLOSE_APP_SPLASH_BG.EVENT);
        } else {
            customTrackingParams.pag = pag;
            view.trackEventWithData(view.TRACKING.CLOSE_APP_SPLASH_BG.EVENT, customTrackingParams);
        }
    }

    function trackCloseDesktop(e) {
        const $currentTarget = $(e.currentTarget);
        const version = $currentTarget.attr('data-splash-version');
        const pnr = $currentTarget.attr('data-openticket-pnr');
        let customTrackingParams = {};

        if (version === 'refund') {
            view.TRACKING.CLOSE_APP_SPLASH_REFUND.PNR = pnr;
            view.trackEventWithData(view.TRACKING.CLOSE_APP_SPLASH_REFUND.EVENT);
        } else {
            customTrackingParams.pag = view.TRACKING.PAGE.CUSTOMER_SUPPORT_LAYER;
            view.TRACKING.CLOSE_APP_SPLASH_ICON_DESKTOP.PNR = pnr;
            view.trackEventWithData(view.TRACKING.CLOSE_APP_SPLASH_ICON_DESKTOP.EVENT, customTrackingParams);
        }
    }

    function trackCloseMobile(e) {
        const $currentTarget = $(e.currentTarget);
        const version = $currentTarget.attr('data-splash-version');
        const pnr = $currentTarget.attr('data-openticket-pnr');
        let customTrackingParams = {};

        if (version === 'accepted') {
            customTrackingParams.pag = view.TRACKING.PAGE.ACCEPTED_LAYER;
            view.TRACKING.CLOSE_APP_SPLASH_ACCEPT.PNR = pnr;
            view.trackEventWithData(view.TRACKING.CLOSE_APP_SPLASH_ACCEPT.EVENT, customTrackingParams);
        } else if (version === 'rejected') {
            customTrackingParams.pag = view.TRACKING.PAGE.ACCEPTED_LAYER;
            view.TRACKING.CLOSE_APP_SPLASH_REJECT.PNR = pnr;
            view.trackEventWithData(view.TRACKING.CLOSE_APP_SPLASH_REJECT.EVENT, customTrackingParams);
        } else if (version === 'refund') {
            view.TRACKING.CLOSE_APP_SPLASH_REFUND.PNR = pnr;
            view.trackEventWithData(view.TRACKING.CLOSE_APP_SPLASH_REFUND.EVENT);
        }
    }

    return module;
}

function renderTemplate(view, version, {cityImageUrl, pnrInfo, cityName, buyerName, fallbackImageUrl, bookingId, notificationManagerScope}) {
    const newElement = document.createElement('div');
    newElement.innerHTML = view.templates.appSplashOverlay({
        keys: view.keys,
        device: getDevice(),
        brandName: getBrandName(),
        buyerName,
        bookingId,
        cityImageUrl,
        fallbackImageUrl,
        pnrInfo,
        cityName,
        version,
        versions,
        notificationManagerScope,
        ...getKeys(view, versionsKeys[version], buyerName),
    });

    return newElement.firstChild;
}

function getKeys(view, version, buyerName = '') {
    const capitalizedVersion = Odigeo._.capitalize(version);
    const {keys} = view;
    return {
        title: keys[`appSplash${capitalizedVersion}Title`],
        subtitle: keys[`appSplash${capitalizedVersion}Subtitle`],
        notification: {
            now: keys[`appSplash${capitalizedVersion}NotificationNow`],
            greeting: Odigeo.Utils.replaceCmsKeyArgs(keys[`appSplash${capitalizedVersion}NotificationGreeting`], buyerName),
            body: keys[`appSplash${capitalizedVersion}NotificationText`],
            giftCard: keys[`appSplash${capitalizedVersion}NotificationGiftCard`],
        },
        background: {
            message: keys[`appSplash${capitalizedVersion}BackgroundTrip`],
            more: keys[`appSplash${capitalizedVersion}BackgroundTripMore`],
        },
    };
}

function getBrandName() {
    return {
        ED: 'eDreams',
        OP: 'Opodo',
        GV: 'GoVoyages',
        TL: 'Travellink',
    }[Odigeo.SessionScope.brand];
}

function getDevice() {
    if (Odigeo.Device.navigator.isAndroid) {
        return 'android';
    } else if (Odigeo.Device.navigator.isIOS) {
        return 'ios';
    } else {
        return 'unknown';
    }
}

function isMobile() {
    return Odigeo.SessionScope.flow === 'mobile';
}

function openSurvey(view, lastVersion) {
    if (lastVersion === versions.accepted) {
        view.externalSurvey(SURVEY_EVENT_ACCEPT);
    } else if (lastVersion === versions.rejected) {
        view.externalSurvey(SURVEY_EVENT_REJECT);
    }
}

function getImageUrl(iata) {
    return `${Odigeo.UserArea.imagePath}onefront/destinations/${iata}_640x480.jpg`;
}

module.exports = {
    factory: appSplashOverlay,
    versions,
};

